import { useIntl } from 'react-intl';
import { BaseGlobalReportPage } from '../common/GlobalReportPage';
import { GlobalAudiosNoMatchesReportView } from './GlobalAudiosNoMatchesReportView';

type Props = Record<string, never>;

export function GlobalNoMatchesReportPage(p: Props) {
  const { $t } = useIntl();

  return (
    <BaseGlobalReportPage
      title={$t({
        id: 'audit.reportsScreen.noMatches.title',
        defaultMessage: 'Archivos sin matches',
      })}
    >
      <GlobalAudiosNoMatchesReportView />
    </BaseGlobalReportPage>
  );
}
